import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_RED } from "../../config/constants";

const Connector13ARed13BRed = ({ state, workState }) => (
   <g id="Track13Red13BRed-connector" transform="translate(1823.000000, 1146.000000)">
      <g id="line"
         transform="translate(0.000000, 0.933594)"
         stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
         strokeLinecap="round"
      >
         <line x1="80" y1="75.0664062" x2="68" y2="44.0664062" id="Path-7"
               strokeWidth={tracksWidth}
               strokeLinejoin="round"/>
      </g>
   </g>
);

export default Connector13ARed13BRed;
